import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { GliderItem, IGliderItem } from '../../atoms';
import { IGliderComponent } from '../glider-wrapper/glider-wrapper';

export type MenuGliderItemsVariant = 'mgv' | 'wide';

export interface IMenuGliderItems extends IGliderComponent<MenuGliderItemsVariant> {
  items?: IGliderItem[];
  isSSR?: boolean;
}

const MenuGliderItems: React.FC<IMenuGliderItems> = ({
  isSSR = false,
  items,
  activeSlideIndex,
  onItemSelectedCallback,
}) => {
  const menuList = useMemo(
    () =>
      items?.map((item, index) => (
        <GliderItem
          key={index}
          {...item}
          onItemSelectedCallback={onItemSelectedCallback}
          itemState={index === activeSlideIndex ? 'focused' : item.itemState}
        />
      )),
    [items, activeSlideIndex, onItemSelectedCallback]
  );

  return isSSR ? (
    <div className="glider-wrapper glider-wrapper--ccr glider-wrapper--ssr">
      <div className="glider-contain">
        <div className="glider-component glider">
          <div className="glider-track--custom glider-track">{menuList}</div>
        </div>
      </div>
    </div>
  ) : (
    <React.Fragment>{menuList}</React.Fragment>
  );
};

if (process.env.NODE_ENV !== 'production') {
  MenuGliderItems.propTypes = {
    activeSlideIndex: PropTypes.number,
    isSSR: PropTypes.bool,
    items: PropTypes.array,
    onItemSelectedCallback: PropTypes.func,
    trackingData: PropTypes.object,
    variant: PropTypes.oneOf<MenuGliderItemsVariant>(['mgv', 'wide']),
  };
}

export default MenuGliderItems;
